<template>
  <section class="section-body has-background-dark">
    <div class="card box">
      <div class="is-flex">
        <div class="card-image">
          <img :src="logo" alt="Placeholder image"/>
        </div>
        <div style="width: 100%;"><span class="tag is-danger is-pulled-right">CARFAX</span></div>
      </div>
      <div class="card-content has-text-left">
        <div class="media">
          <div class="media-content">
            <p class="title is-4">Carfax</p>
            <p class="subtitle is-6">session notification</p>
          </div>
        </div>

        <div class="content">
          <div class="columns is-multiline box has-background-success">
            <div class="column is-2 has-text-right">
              <i class="fal fa-check-circle fa-2x has-text-white"></i>
            </div>
            <div class="column has-text-white">
              <p class="is-size-5">Your CARFAX session has been activated.</p>
              <p class="is-size-7">You may close this window at your convenience.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CarfaxCallbackCompleted',
  data () {
    return {
      logo: require('@/assets/eag_logo.png')
    }
  },
  created () {
    this.$emit('is-home', false)
    this.$emit('show-header', false)
    this.$emit('show-footer', false)
  },
  mounted () {
  }
}
</script>
<style scoped>
  .card {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 560px;
  }

  .card-image {
    width: 282px;
  }

  .section-body {
    width: 100%;
    height: 100%;
  }
</style>
